/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Name_AriaInputs */

const en_form_name_aria = /** @type {(inputs: Form_Name_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your name`)
};

const ar_form_name_aria = /** @type {(inputs: Form_Name_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسمك`)
};

const bn_form_name_aria = /** @type {(inputs: Form_Name_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার নাম`)
};

const de_form_name_aria = /** @type {(inputs: Form_Name_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Name`)
};

const es_form_name_aria = /** @type {(inputs: Form_Name_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu nombre`)
};

const fr_form_name_aria = /** @type {(inputs: Form_Name_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre nom`)
};

const pt_form_name_aria = /** @type {(inputs: Form_Name_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu nome`)
};

const zh_form_name_aria = /** @type {(inputs: Form_Name_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的名字`)
};

const tr_form_name_aria = /** @type {(inputs: Form_Name_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adınız`)
};

const ru_form_name_aria = /** @type {(inputs: Form_Name_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваше имя`)
};

const pl_form_name_aria = /** @type {(inputs: Form_Name_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje imię i nazwisko`)
};

/**
* | output |
* | --- |
* | "Your name" |
*
* @param {Form_Name_AriaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_name_aria = /** @type {((inputs?: Form_Name_AriaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Name_AriaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_name_aria(inputs)
	if (locale === "bn") return bn_form_name_aria(inputs)
	if (locale === "de") return de_form_name_aria(inputs)
	if (locale === "es") return es_form_name_aria(inputs)
	if (locale === "fr") return fr_form_name_aria(inputs)
	if (locale === "pt") return pt_form_name_aria(inputs)
	if (locale === "zh") return zh_form_name_aria(inputs)
	if (locale === "tr") return tr_form_name_aria(inputs)
	if (locale === "ru") return ru_form_name_aria(inputs)
	if (locale === "pl") return pl_form_name_aria(inputs)
	return en_form_name_aria(inputs)
});